import * as React from 'react';
import translate from '../../../../locale/translate';

import SummaryRow from './SummaryRow';
import ISettings from './ISettings';

import { getDisplayValue } from '../../util/StringUtil';

interface IProps {
    nodes: any[],
    states: any,
    startDate: Date,
    endDate: Date,
    settings: ISettings,
}

const AVAILABLE_COLS = [
    'name',
    'alertDuration',
    'okDuration',
    'dayDistribution',
    'alertPercentage',
    'okPercentage',
];

const COL_TITLES = {
    name: translate.gettext("Name"),
    alertDuration: translate.gettext("Alert"),
    okDuration: translate.gettext("OK"),
    dayDistribution: translate.gettext("Distribution over timespan"),
    alertPercentage: translate.gettext("Alert"),
    okPercentage: translate.gettext("OK"),
};

const COL_CLASSES = {
    alertDuration: 'col-xs-1 text-right',
    okDuration: 'col-xs-1 text-right',
    dayDistribution: 'col-xs-5 text-right',
    alertPercentage: 'col-xs-1 text-right',
    okPercentage: 'col-xs-1 text-right',
};

export default class SummaryTable extends React.Component<IProps, void> {
    static propTypes = {
        nodes: React.PropTypes.array.isRequired,
        states: React.PropTypes.object.isRequired,
        startDate: React.PropTypes.object.isRequired,
        endDate: React.PropTypes.object.isRequired,
        settings: React.PropTypes.object.isRequired,
    };

    renderColumn(name: string, settings: ISettings) {
        if (getDisplayValue(name, settings)) {
            return (
                <th key={name} className={COL_CLASSES[name]}>{COL_TITLES[name]}</th>
            );
        }

        return;
    }

    render() {
        const { nodes, states, startDate, endDate, settings } = this.props;

        let rows = nodes.map((node) => {
            return (
                <SummaryRow
                    key={node.id}
                    node={node}
                    states={states[node.id]}
                    startDate={startDate}
                    endDate={endDate}
                    settings={settings}
                    />
            );
        });

        return (
            <table className="table">
                <thead>
                    <tr>
                        <th key='name' className={COL_CLASSES['name']}>{COL_TITLES['name']}</th>
                        {AVAILABLE_COLS.map(name => {
                            return this.renderColumn(name, settings);
                        })}
                    </tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
            </table>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/alerts/listAlertSummary/SummaryTable.tsx